export default __webpack_public_path__ + "static/media/hassan14.5c1eabb2.JPG";